export default account => {
  if (!account || !account.get) return null;
  if (account.get('ask')) return 'Aksjesparekonto';
  if (account.get('marginAccount')) return 'Marginkonto';
  return 'Ordinær aksjekonto';
};
